import React, { useState, useEffect, useCallback } from "react";
import { Stack, Box, Typography, IconButton } from "@mui/material";
import WelcomeNameContainer from "./LaunchComponent/WelcomeNameContainer";
import { ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";
import { motion } from "framer-motion";
import Rating from "@mui/material/Rating";
import Avatar from '@mui/material/Avatar';
import PersonOutlineRoundedIcon from '@mui/icons-material/PersonOutlineRounded';
import testimonials from "../data/testimonials.json"

const Testimonials = () => {
  const [index, setIndex] = useState(0);

  const nextSlide = useCallback(() => {
    setIndex((prev) => (prev + 1) % testimonials.length);
  }, []);

  const prevSlide = () => {
    setIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  // Auto-play every 5 seconds
  useEffect(() => {
    const interval = setInterval(nextSlide, 5000);
    return () => clearInterval(interval);
  }, [nextSlide]);

  return (<Stack>
    <Stack alignItems="center" justifyContent="center">
      <WelcomeNameContainer currentComp="TestimonialsPage" />

      <Box sx={{ position: "relative", width: "100%",marginTop:"5%", textAlign: "center" }}>
        {/* Testimonial Cards */}
        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", position: "relative", height: "300px" }}>
          {testimonials.map((testimonial, i) => {
            const position = (i - index + testimonials.length) % testimonials.length;
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{
                  opacity: position === 0 ? 1 : 0.9,
                  scale: position === 0 ? 1 : 0.9,
                  x: position === 0 ? 0 : position === 1 ? 150 : -150,
                }}
                transition={{ duration: 0.5 }}
                style={{
                  position: "absolute",
                  width: "30rem",
                  height: "15rem",
                  padding: "16px",
                  background: position === 0 ? "#fff" : "#d1c4e9", // Light purple for non-focused cards
                  boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
                  border: "1px solid black",
                  borderRadius: 4,
                  zIndex: position === 0 ? 2 : 1,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                }}
              >
                <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                  {/* <img
                    src={process.env.PUBLIC_URL + "/Images/pp-border-round.png"}
                    width="60px"
                    alt="profile"
                    style={{ position: "relative", top: "-40px", marginBottom: "-40px" }}
                  /> */}
                  <Avatar sx={{ position: "relative", top: "-40px",
                     marginBottom: "-40px", width: 50, height: 50
                     }}>
                    <PersonOutlineRoundedIcon/></Avatar>
                  <img
                    src={process.env.PUBLIC_URL + "/Images/double-quotes.png"}
                    width="80px"
                    alt="quotes"
                    style={{ position: "relative", top: "-40px", marginBottom: "-40px" }}
                  />
                </div>

                <Typography
                  sx={{
                    height: "60%",
                    color: "rgb(81, 80, 80)",
                    boxSizing: "border-box",
                    marginY: "10px",
                    overflow: "hidden",
                  }}
                  variant="body1"
                >
                  {testimonial.feedback}
                </Typography>

                <hr />

                <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between" }}>
                  <div style={{ marginTop: "5px",textAlign:"left" }}>
                    <div style={{ color: "#460073", fontWeight: "bold" }}>{testimonial.name}</div>
                    <Typography>{testimonial.designation}</Typography>
                  </div>
                  <Rating name="read-only" value={testimonial.rating} readOnly />
                </div>
              </motion.div>
            );
          })}
        </Box>

        {/* Navigation Buttons & Indicators */}
        <Stack direction="row" spacing={3} alignItems="center" justifyContent="center" sx={{ marginTop: "40px" }}>
          <IconButton onClick={prevSlide}>
            <ArrowBackIos />
          </IconButton>

          {/* Indicators */}
          <Stack direction="row" spacing={1}>
            {testimonials.map((_, i) => (
              <Box
                key={i}
                sx={{
                  width: 10,
                  height: 10,
                  borderRadius: "50%",
                  backgroundColor: i === index ? "#673ab7" : "#ccc",
                  transition: "background-color 0.3s ease",
                }}
              />
            ))}
          </Stack>

          <IconButton onClick={nextSlide}>
            <ArrowForwardIos />
          </IconButton>
        </Stack>
      </Box>
    </Stack>
    </Stack>
  );
};

export default Testimonials;
